<script setup lang="ts">
// Bottom call-to-action: a tinted panel with the claim-username input,
// shared by the landing, pricing, and docs pages.
withDefaults(defineProps<{
  title?: string
  description?: string
}>(), {
  title: 'Claim your username',
  description: 'Free forever. Your page is live in minutes.'
})
</script>

<template>
  <UContainer class="py-16 sm:py-20 lg:py-24">
    <div class="relative overflow-hidden rounded-3xl border border-primary-400/15 bg-primary-500/4 px-6 py-12 text-center sm:px-12 sm:py-16 shadow-(--surface-shadow)">
      <!-- Soft corner glows -->
      <div
        aria-hidden="true"
        class="pointer-events-none absolute -left-24 -top-24 size-72 rounded-full bg-primary-500/10 blur-3xl"
      />
      <div
        aria-hidden="true"
        class="pointer-events-none absolute -bottom-24 -right-24 size-72 rounded-full bg-fuchsia-500/6 blur-3xl"
      />

      <div class="relative">
        <h2 class="text-2xl font-bold text-highlighted sm:text-3xl">
          {{ title }}
        </h2>
        <p class="mt-3 text-base text-muted sm:text-lg">
          {{ description }}
        </p>

        <div class="mx-auto mt-8 flex max-w-xl justify-center">
          <HeroClaimUsername
            variant="compact"
            location="bottom"
          />
        </div>

        <ul class="mt-2 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <li class="flex items-center gap-1.5 text-sm text-muted">
            <UIcon
              name="i-lucide-check"
              class="size-4 text-primary-400"
            />
            Free forever
          </li>
          <li class="flex items-center gap-1.5 text-sm text-muted">
            <UIcon
              name="i-lucide-check"
              class="size-4 text-primary-400"
            />
            No credit card needed
          </li>
        </ul>
      </div>
    </div>
  </UContainer>
</template>
